import React from "react";
import { useTranslation } from "react-i18next";

const TierBudgetDecreased = ({ notification }) => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="notification-title">
        {t("notification_tier_budget_decrease_title")}
      </h4>
      <p className="notification-subtitle">
        {t("notification_tier_budget_decrease_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_tier_budget_decrease_description")}
      </p>
    </>
  );
};

export default TierBudgetDecreased;
